import rootReducer from '../reducers' //Tree
import { createStore, applyMiddleware, compose } from 'redux'; // Redux 组件
import thunkMiddleware from 'redux-thunk' // Logger
import createLogger from 'redux-logger' // Logger2

const loggerMiddleware = createLogger() // Create Tree

const logger = store => next => action => { // Logger Show
    if (console) {
        console.log('dispatching', action)
    }
    next(action)
    if (console) {
        console.log('next state', store.getState())
    }

}

const omnitureAppend = store => next => action => {
    if (typeof window !== 'undefined' && $ && typeof $.fn.setOmniture === 'function') {
        $("[data-omniture]").each(function () { $(this).setOmniture(); });
    }
    next(action);
};

export default function configureStore(preloadedState) { // Create 
    let middleware = null;
    if (typeof window !== 'undefined') {
        middleware = applyMiddleware(thunkMiddleware, omnitureAppend);
    } else {
        middleware = applyMiddleware(thunkMiddleware);
    }
    const store = createStore(
        rootReducer,
        preloadedState,
        middleware
        // applyMiddleware(thunkMiddleware, loggerMiddleware, logger, omnitureAppend)
    );
    return store;
}


// WEBPACK FOOTER //
// ./common/store/configureStore.js